import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Smartphone, CreditCard } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-20 md:py-32 px-5 bg-white relative overflow-hidden" data-id="element-6">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-surface/40 rounded-full blur-3xl -z-10 opacity-50" data-id="element-7" />

      <div className="max-w-2xl mx-auto text-center relative z-10" data-id="element-8">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-9">
          <h2 className="text-3xl md:text-5xl font-serif font-semibold text-heading mb-6 leading-tight" data-id="element-10">
            Empieza esta noche con un plan claro
          </h2>

          <p className="text-lg text-body mb-10" data-id="element-11">
            Una guía hecha para mamás reales. Sin cursos largos. Sin teoría
            confusa.
          </p>

          <div className="bg-cream p-8 md:p-10 rounded-3xl border border-rose/20 shadow-soft" data-id="element-12">
            <div className="mb-6" data-id="element-13">
              <span className="text-sm font-semibold text-terracotta uppercase tracking-wider block mb-2" data-id="element-14">
                Precio Especial
              </span>
              <div className="flex items-center justify-center space-x-3" data-id="element-15">
                <span className="text-5xl font-serif font-bold text-heading" data-id="element-16">
                  $8.39
                </span>
                <span className="text-xl text-body line-through decoration-rose/60" data-id="element-17">
                  $17
                </span>
              </div>
            </div>

            {/* Replace href with actual Shopify checkout URL */}
            <a id="comprar" href="https://guiadownload.com/products/tu-bebe" target="_blank" rel="noopener noreferrer" className="group relative inline-flex items-center justify-center w-full px-8 py-5 bg-terracotta text-white rounded-full font-semibold text-xl transition-all hover:bg-terracotta-dark hover:scale-[1.02] active:scale-[0.98] shadow-lg shadow-terracotta/20 mb-6 scroll-mt-24" data-id="element-18">
              Comprar ahora →
            </a>

            <div className="flex flex-col items-center space-y-4" data-id="element-19">
              <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm text-heading font-medium" data-id="element-20">
                <span className="flex items-center" data-id="element-21">
                  <ShieldCheck className="w-4 h-4 mr-1.5 text-terracotta" data-id="element-22" />{' '}
                  Compra segura
                </span>
                <span className="flex items-center" data-id="element-23">
                  <Smartphone className="w-4 h-4 mr-1.5 text-terracotta" data-id="element-24" />{' '}
                  Acceso digital
                </span>
                <span className="flex items-center" data-id="element-25">
                  <CreditCard className="w-4 h-4 mr-1.5 text-terracotta" data-id="element-26" /> Pago
                  en Shopify
                </span>
              </div>

              <p className="text-xs text-body" data-id="element-27">
                PDF descargable. Acceso inmediato después de la compra.
              </p>
              <p className="text-[11px] text-body/70" data-id="element-28">
                Entregado por{' '}
                <span className="font-semibold text-heading" data-id="element-29">
                  GuiaDownload.com
                </span>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}